import { z } from "zod";

export const mergeNodeConfigSchema = z
  .object({
    merge_node_type: z.string().min(1, "El tipo de nodo es requerido"),
    entries: z
      .array(
        z.object({
          name: z.string().min(1, "El nombre descriptivo es requerido"),
          nodeId: z.string().uuid("El ID del nodo debe ser un UUID válido"),
          type: z.literal("MERGE_ENTRY"),
        }),
      )
      .min(2, "Se requieren mínimo 2 entradas")
      .max(10, "Máximo 10 entradas permitidas"),
    manual_continue: z.boolean().default(false),
  })
  .refine(
    (data) => {
      const nodeIds = data.entries.map((entry) => entry.nodeId);
      const uniqueIds = new Set(nodeIds);
      return nodeIds.length === uniqueIds.size;
    },
    {
      message: "No se puede duplicar el mismo nodo en múltiples entradas",
      path: ["entries"],
    },
  );

export type MergeNodeConfigValidation = z.infer<typeof mergeNodeConfigSchema>;
